module.exports = __webpack_public_path__ + "static/media/double_pleated.ecf3e89e.svg";